/*
Slice for managing configuration state in a Redux-Toolkit store.

Methods:
- `store`: Stores the configuration data.
- `get`: Retrieves the stored configuration data.
- `setValue`: Sets a specific key-value pair in the configuration state.
- `getValue`: Retrieves a specific value from the configuration state by key.

Usage:
Connect store:
store.js:
  import configStore from '../../lib/configStore';
  add 'config: configStore,' to the reducer object in configureStore.

Store data:
  import { useSelector, useDispatch } from "react-redux";
  import { configActions } from '../../lib/configStore';
  ...
  const dispatch = useDispatch();
  if (props.railsData) {
    dispatch( configActions.store( props.railsData ) );
  }

Retrieve data:
  import { useSelector } from 'react-redux';

  const configData = useSelector(state => state.config.data);
*/

import { createSlice } from '@reduxjs/toolkit';

const initialState = { data: null }

const configSlice = createSlice({
  name: 'config',
  initialState: initialState,
  reducers: {
    store(state, action) {
      state.data = action.payload;
    },
    get(state) {
      return state.data;
    },
    setValue(state, action) {
      state[action.payload.key] = action.payload.value;
    },
    getValue(state, action) {
      return state[action.payload.key];
    },
  },
});

export const configActions = configSlice.actions;

export default configSlice.reducer;